import General from './apis/General'
import Map from './apis/Map'
import Dem from './apis/Dem'
import Coordinate from './apis/Coordinate'
import Aerscreen from './apis/Aerscreen'

export default {
  General,
  Map,
  Dem,
  Coordinate,
  Aerscreen
}
